import React, { createContext,useState } from 'react'
import client from '../API/client';
// import { createContext, useEffect, useState } from "react";
export const UserContextData = createContext();

export const AuthContext = ({children}) => {
    const [currentUser, setCurrentUser] = useState(
        JSON.parse(localStorage.getItem("user")) || null
      );
      const [designer,setDesigner] =useState(
        JSON.parse(localStorage.getItem("designer")) || null
      )
      const [recruiter,setRecruiter] =useState(
        JSON.parse(localStorage.getItem("recruiter")) || null
      )
      const [userid,setUserid]=useState(
        localStorage.getItem("user_id") || null
      )

  return (
    <UserContextData.Provider value={{ Designer : designer , User:currentUser , Recruiter : recruiter , id : userid }}>
     {children}
    </UserContextData.Provider>
  )
}
